import { defaultAccessLevels, defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_Resource = 'Resource';
export const DomainNamespace_ResourceManager = 'Resource Manager';
export const PermissionKey_ResourceGeneral = 'resource-general';
export const PermissionKey_ResourceV1Viewer = 'permission-key--resource-v1-viewer';
export const PermissionKey_ResourceV2Viewer = 'permission-key--resource-v2-viewer';
export const ResourcePermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_Resource, defaultAccessLevels);
export const ResourceManagerPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_ResourceManager, defaultUIAccessLevels);
export const ResourceTypeToIconMap = {
    'Laboratory': 'Laboratory',
    'Imaging': 'Imaging',
    'Procedures': 'Vital Signs',
    'Consultations': 'Physician',
    'EKG': 'Physician'
};
//# sourceMappingURL=consts.js.map